import * as Types from '../../generated/types.cms';

import { endpoint, fetchParams } from '@payflip/employee-client/cms-gql-config';
import { useQuery, UseQueryOptions } from 'react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint as string, {
    method: "POST",
    ...(fetchParams),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type GetMaintenanceScreenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMaintenanceScreenQuery = { __typename?: 'Query', maintenanceScreen?: { __typename?: 'MaintenanceScreenEntityResponse', data?: { __typename?: 'MaintenanceScreenEntity', attributes?: { __typename?: 'MaintenanceScreen', title?: string | null, body?: string | null, payflipLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, maintenanceImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null };



export const GetMaintenanceScreenDocument = `
    query GetMaintenanceScreen {
  maintenanceScreen {
    data {
      attributes {
        title
        body
        payflipLogo {
          data {
            attributes {
              url
            }
          }
        }
        maintenanceImage {
          data {
            attributes {
              url
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetMaintenanceScreenQuery = <
      TData = GetMaintenanceScreenQuery,
      TError = unknown
    >(
      variables?: GetMaintenanceScreenQueryVariables,
      options?: UseQueryOptions<GetMaintenanceScreenQuery, TError, TData>
    ) => {
    
    return useQuery<GetMaintenanceScreenQuery, TError, TData>(
      variables === undefined ? ['GetMaintenanceScreen'] : ['GetMaintenanceScreen', variables],
      fetcher<GetMaintenanceScreenQuery, GetMaintenanceScreenQueryVariables>(GetMaintenanceScreenDocument, variables),
      options
    )};
